import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../routers/AuthProvider';
import { useForm } from '../../hooks/useForm';
import backArrowIcon from '../../assets/img/back-arrow.png'
import '../../assets/css/common.css';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
import { Toast } from '../../components/ToastComponent';


export default function CreateRetailCustomer() {
    const backPath = '/customer/retail';
    const { handleInputChange, formData, submitForm, setFormData, setError, error } = useForm();

    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
    const onSubmit = (e) => {
        setLoading(true)
        e.preventDefault();
        const data = {
            member_code: memberCode,
            ...formData,
            status: 'ACTIVE'
        }
        submitForm('POST', '/retailCustomer', data, () => {
            navigate(backPath)
        }, "Successfully Created");
    }
    const [memberCode, setMemberCode] = useState();
    const [address, setAddress] = useState();
    // const localData = JSON.parse(localStorage.getItem('user')) ?? {};
    useEffect(() => {
        axios.get(API_URL + '/common/address', {
            // headers: {
            //     'Authorization': `Bearer ${localData?.token}`
            // },
            withCredentials: true
        })
            .then(response => {
                setAddress(response.data.data)
            })
    }, [])

     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])

    // useEffect(() => {
    //     const elem = document.querySelector('select[name="city_id"].x-input.dropdown');
    //     const value = elem?.children[1]?.value;
    //     setFormData({ ...formData, city_id: value })
    // }, [formData.district_id]);

    // useEffect(() => {
    //     const elem = document.querySelector('select[name="township_id"].x-input.dropdown');
    //     const value = elem?.children[1]?.value;
    //     setFormData({ ...formData, township_id: value })
    // }, [formData.city_id]);

    const [errorPhone1Message, setErrorPhone1Message] = useState("");
    const [errorPhone2Message, setErrorPhone2Message] = useState("");
    const [errorPhone3Message, setErrorPhone3Message] = useState("");
    const [errorPhone4Message, setErrorPhone4Message] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (/[^0-9]/.test(e.target.value)) {
            //setErrorPhoneMessage("Only numbers are allowed.");
            if (name === 'phone1') {
                setErrorPhone1Message("Only numbers are allowed.");
            } else if (name === 'phone2') {
                setErrorPhone2Message("Only numbers are allowed.");
            }
            else if (name === 'phone3') {
                setErrorPhone3Message("Only numbers are allowed.");
            }
            else {
                setErrorPhone4Message("Only numbers are allowed.");
            }
        } else {
            setErrorPhone1Message("");
            setErrorPhone2Message("");
            setErrorPhone3Message("");
            setErrorPhone4Message("");  // Clear message when input is valid
        }

        // Allow digits only for phone inputs
        const numericValue = value.replace(/[^0-9]/g, "");
        setFormData((prev) => ({
            ...prev,
            [name]: numericValue,
        }));

    };

    const [errorMessage, setErrorMessage] = useState("");

    // const AddressForm = ({ address }) => {
    //     const [formData, setFormData] = useState({
    //         district_id: '',
    //         city_id: '',
    //         township_id: '',
    //         address: ''
    //     });
    // }
    const handleStateChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
        let updated = { ...prev, [name]: value };

        if (name === 'district_id') {
            updated.city_id = '';
            updated.township_id = '';
        } else if (name === 'city_id') {
            updated.township_id = '';
        }

        return updated;
    });
};








    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container' style={{ height: 'auto' }}>
                <h1 className='sub-page-title'>Create New Retail Customer</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <div className='pt-5'>
                            <h2 className='sub-title mb-8'>Retail Customer Informations</h2>
                            <div className='grid grid-cols-2 gap-9'>
                                <div className='grow'>
                                    <label className='x-label input-required'>Customer Name</label>
                                    <input type='text'
                                        required
                                        name='customer_name'
                                        onChange={handleInputChange}
                                        className='x-input' />
                                </div>
                                <div className='grow'>
                                    <label className='x-label input-required'>Member Card Number</label>
                                    <input
                                        type='text'
                                        required
                                        name='member_code'
                                        value={memberCode}
                                        pattern="[0-9]+"
                                        onChange={e => {
                                            // Show message if non-numeric character is present
                                            if (/[^0-9]/.test(e.target.value)) {
                                                setErrorMessage("Only numbers are allowed.");
                                            } else {
                                                setErrorMessage(""); // Clear message when input is valid
                                            }
                                            setMemberCode(e.target.value.replace(/[^0-9]/g, ""))
                                        }}
                                        onKeyDown={e => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                            }
                                        }}
                                        className='x-input'

                                    //const numericValue = e.target.value.replace(/[^0-9]/g, "");

                                    />
                                    {errorMessage && (
                                        <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                    )}


                                </div>
                                <div className='grow'>
                                    <label className='x-label input-required'>Phone 1</label>
                                    <input type='text'
                                    placeholder='09xxxxxxx'
                                        required
                                        name='phone1'
                                        value={formData.phone1 || ""}
                                        onChange={handleChange}
                                        className='x-input' />
                                    {errorPhone1Message && (
                                        <div className="text-red-500 text-sm mt-1">{errorPhone1Message}</div>
                                    )}

                                </div>

                                <div className='grow'>
                                    <label className='x-label'>Phone 2</label>
                                    <input type='text'
                                        name='phone2'
                                        placeholder='09xxxxxxx'
                                        value={formData.phone2 || ""}
                                        onChange={handleChange}
                                        className='x-input' />
                                    {errorPhone2Message && (
                                        <div className="text-red-500 text-sm mt-1">{errorPhone2Message}</div>
                                    )}

                                </div>
                                <div className='grow'>
                                    <label className='x-label'>Phone 3</label>
                                    <input type='text'
                                        name='phone3'
                                        placeholder='09xxxxxxx'
                                        value={formData.phone3 || ""}
                                        onChange={handleChange}
                                        className='x-input' />
                                    {errorPhone3Message && (
                                        <div className="text-red-500 text-sm mt-1">{errorPhone3Message}</div>
                                    )}
                                </div>
                                <div className='grow'>
                                    <label className='x-label'>Phone 4</label>
                                    <input type='text'
                                        name='phone4'
                                        placeholder='09xxxxxxx'
                                        value={formData.phone4 || ""}
                                        onChange={handleChange}
                                        className='x-input' />
                                    {errorPhone4Message && (
                                        <div className="text-red-500 text-sm mt-1">{errorPhone4Message}</div>
                                    )}
                                </div>
                            </div>
                            <div className='form-divider'></div>
                            <h2 className='sub-title mb-8'>Other Informations</h2>
                            <div className='grid grid-cols-2 gap-9'>
                                <div className='grow'>
                                    <label className='x-label'>State</label>
                                    <div className='dd-container'>
                                        <select
                                            type='text'
                                            name='district_id'
                                            value={formData.district_id || ''}
                                            onChange={handleStateChange}
                                            className='x-input dropdown'

 
                                        >
                                            <option value='' disabled>Select</option>
                                            {address && address.district.map((item, index) => (
                                                <option key={index} value={item.district_id}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className='grow'>
                                    <label className='x-label'>City</label>
                                    <div className='dd-container'>
                                        <select
                                            type='text'
                                            name='city_id'
                                            value={formData.city_id || ''}
                                            onChange={handleStateChange}
                                           // defaultValue={formData.city_id ? formData.city_id : ''}
                                            className='x-input dropdown'
                                        >
                                            <option value='' disabled>Select</option>
                                            {address && address.city.filter(item => item.district_id === parseInt(formData.district_id)).map((item, index) => (
                                                <option key={index} value={item.city_id}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className='grow'>
                                    <label className='x-label'>Township</label>
                                    <div className='dd-container'>
                                        <select
                                            type='text'
                                            name='township_id'
                                            value={formData.township_id || ''}
                                            onChange={handleStateChange}
                                            //defaultValue={formData.township_id ? formData.township_id : ''}
                                            className='x-input dropdown'
                                        >
                                            <option value='' disabled>Select</option>
                                            {address && address.township.filter(item => item.city_id === parseInt(formData.city_id)).map((item, index) => {
                                                return <option key={index} value={item.township_id}>{item.name}</option>

                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className='grow'>
                                    <label className='x-label input-required'>Address</label>
                                    <input type='text'
                                        required
                                        name='address'
                                        onChange={handleInputChange}
                                        className='x-input' />
                                </div>
                            </div>
                        </div>
                        <div className='mt-8 form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button type='submit' className='gold-btn'>Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}